import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-promocion',
  templateUrl: './promocion.component.html',
  styleUrls: ['./promocion.component.css']
})
export class PromocionComponent implements OnInit {
  dataActual: any = null;

  infoPromo: any = {
    // promoguiasweb: {
    //   titulo: "TUFESAPACK 2025 - Promoción exclusiva para clientes nuevos",
    //   descripcion: `¡Llegó la PROMO 2025 con TUFESAPACK!\n
    //   ¿Listo para ahorrar y enviar más? Aprovecha nuestra promoción exclusiva para clientes nuevos:\n
    //   ●	1,000 guías web a $80 c/u (más IVA)
	  //   ●	500 guías web a $100 c/u (más IVA)
    //   `,
    //   beneficios: [
    //     "Hasta 20 kg por guía",
    //     "Recolección y entrega a domicilio",
    //     "Aplica solo en sucursales con servicio",
    //     "Promoción válida en toda la cobertura de sucursales TUFESAPACK."
    //   ],
    //   terminos: [
    //     "Aplica exclusivamente para clientes nuevos con primer consumo de contrato.",
    //     "Vigencia: del 14 al 18 de noviembre 2025.",
    //     "Precios más IVA.",
    //     "No aplica con otras promociones.",
    //     "Sujeto a cobertura TUFESAPACK.",
    //     "Máximo 20 kg por guía.",
    //     "Recolección y entrega disponible únicamente en sucursales con servicio activo.",
    //     "No transferible."
    //   ],
    //   imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_guiasWeb.webp",
    //   boton:"Comprar"
    // },
    promonavidad2025:{
      titulo: "🎅✨ ¡La Magia de la Navidad llegó a TUFESAPACK! ✨🎄",
      descripcion:`Participa y gana la Caja Mágica TUFESAPACK con $5,000 en sorpresas 🎁\n
      Esta temporada queremos agradecer tu preferencia con un regalo muy especial. Del 01 al 20 de diciembre, cada envío que realices puede acercarte a ganar nuestra exclusiva Caja Mágica TUFESAPACK: un premio en especie compuesto por artículos navideños, promocionales y tarjeta de regalo para tienda departamental, con un valor de $5,000 MXN.\n
      🎁 ¿Cómo participar?`,
      beneficios: [
        "Realiza un envío en cualquier sucursal TUFESAPACK.",
        "Recibe tu PACK Esfera en mostrador (1 por cliente por día).",
        "Llena tus datos y deposítala en el buzón navideño de la sucursal.",
        "Promoción válida en toda la cobertura de sucursales TUFESAPACK.",
        "🎅¡Cada PACK Esfera es una oportunidad para ganar!"
      ],
      fechasimportantes:`📅 Fechas importantes\n
      Participación válida del: 01 al 20 de diciembre o hasta agotar existencias.
      Sorteo: 20 de diciembre a las 12:00 horas (Tiempo del Pacífico) mediante Facebook Live en la página oficial de TUFESAPACK.
      Entrega del premio: 22 de diciembre.`,
      terminos:[
        "Válido en todas las sucursales TUFESAPACK de México hasta agotar existencias.",
        "Una PACK Esfera por cliente por día, sin importar el número de envíos en la misma fecha.",
        "Aplican términos y condiciones.",
        "El premio no es transferible, no puede canjearse por dinero ni por otros productos o beneficios. Su entrega se realizará únicamente a la persona participante que resulte ganadora y que acredite su identidad.",
      ],
            textonavidad:`¡Envía, participa y vive la magia con TUFESAPACK!
      Porque en esta Navidad, cada envío puede convertirse en un regalo inolvidable.
      #NavidadTUFESAPACK #CajaMágicaTUFESAPACK`,
      bases:`Los datos registrados en la PACK Esfera serán utilizados exclusivamente para identificar al participante y contactarlo en caso de resultar ganador. El tratamiento de la información se realizará conforme al Aviso de Privacidad disponible en www.tufesapack.com/aviso-de-privacidad. No se utilizarán para fines distintos ni se compartirán con terceros ajenos a la promoción.”\n
      La selección del ganador se realizará mediante el portal Appsorteos el día 20 de diciembre de 2025 a las 12:00 horas, en una transmisión en vivo en la página oficial de Facebook de TUFESAPACK. Se elegirán un ganador y dos suplentes para asegurar la correcta asignación del premio.\n
      El ganador será contactado vía llamada telefónica y correo electrónico con los datos proporcionados en su PACK Esfera. En caso de que el ganador no pueda ser localizado tras agotar los intentos razonables (número incorrecto, ausencia de respuesta, correo sin contestar), se asignará el premio al primer suplente y, de persistir la imposibilidad de contacto, al segundo suplente. La sucursal donde se haya depositado la PACK Esfera ganadora apoyará en la búsqueda presencial del participante para agotar todas las opciones de contacto antes de pasar a un suplente.`,
      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_cajaMagica.webp"
    },
    promohermosillo: {
      titulo: "Promoción Hermosillo",
      descripcion: `Hermosillo manda más, ¡y paga por menos!\n
    Aprovecha esta súper promo en Hermosillo:\n
    Solo $25 pesos la recolección y 25% de descuento en tu envío a cualquier destino dentro de la cobertura TUFESA (aplicable en conjunto con recolección).\n
    Pide tu recolección, paga en sucursal o al recoger y deja que nosotros hagamos el resto. ¡Es el momento ideal para mandar todo lo que quieras!`,
      beneficios: [],
      terminos: [
        "Promoción válida únicamente para envíos recolectados con origen en Hermosillo.",
        "Recolección con costo de $25.00 pesos + 25% de descuento en el envío solo si es en conjunto con recolección.",
        "Aplica solo en pagos realizados con efectivo, tarjeta de débito o crédito.",
        "El servicio a domicilio (entrega final) se paga por separado.",
        "El empaque y embalaje tienen costo adicional.",
        "Promoción válida del 7 de abril al 31 de julio de 2025.",
        "No acumulable con otras promociones o descuentos."
      ],
      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_hermosillo.webp"
    },

  };

  constructor(private route: ActivatedRoute, private router: Router, private metaService: Meta) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code && this.infoPromo[code]) {
        this.dataActual = this.infoPromo[code];
      } else {
        this.router.navigate(['/']); // Redirige al inicio si code es inválido o nulo
      }
    });

     this.metaService.updateTag({ name: 'robots', content: 'noindex' });
  }

}